import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";

export const useToast = () => {
  const { t } = useTranslation();

  const toastPromise = <T>(
    promise: Promise<T>,
    options: {
      loading: string;
      success: string | ((result: T) => string);
      error?: string | ((error: unknown) => string);
      onSuccess?: (result: T) => void;
      onError?: (error: unknown) => void;
      onFinally?: () => void;
    }
  ): Promise<T> => {
    return toast
      .promise(promise, {
        loading: options.loading,
        success: (result: T) => {
          const message =
            typeof options.success === "function"
              ? options.success(result)
              : options.success;
          options.onSuccess?.(result);
          return message;
        },
        error: (error: unknown) => {
          const message =
            typeof options.error === "function"
              ? options.error(error)
              : options.error || t("error") || "Fehler aufgetreten";
          options.onError?.(error);
          return message;
        },
      })
      .finally(() => {
        options.onFinally?.();
      }) as Promise<T>;
  };

  const showSuccess = (message: string) => {
    toast.success(message);
  };

  const showError = (message: string) => {
    toast.error(message);
  };

  const showLoading = (message: string) => {
    return toast.loading(message);
  };

  return {
    toastPromise,
    showSuccess,
    showError,
    showLoading,
  };
};
